export default
{
    methods:
    {
        clickRange( range )
        {
            this.customRangeActive = false;

            this.$emit( 'clickRange', range );
        },

        clickCustomRange()
        {
            this.customRangeActive = true;

            this.$emit( 'showCustomRange' );
        }
    }
}